import React from 'react';
import './BottomNav.css';

const BottomNav = ({ activeTab, setActiveTab }) => {
  const navItems = [
    { id: 'dashboard', icon: '🏠', label: 'Dashboard' },
    { id: 'units', icon: '⏱️', label: 'Units', tour: 'packages' },
    { id: 'team', icon: '👥', label: 'Team', tour: 'team' }
  ];

  return (
    <nav className="bottom-nav">
      <div className="nav-glow"></div>
      <div className="nav-container">
        {navItems.map((item, index) => (
          <button
            key={item.id}
            className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
            aria-label={item.label}
            data-tour={item.tour}
          >
            <div className="nav-item-inner">
              <div className="nav-icon-wrap">
                <span className="nav-icon">{item.icon}</span>
                <div className="nav-ring"></div>
              </div>
              <span className="nav-label">{item.label}</span>
            </div>
            <div className="nav-indicator"></div>
            <div className="nav-pulse"></div>
          </button>
        ))}
      </div>
      <div className="nav-border-animation"></div>
    </nav>
  );
};

export default BottomNav;
